import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

const config = {
  pending: { dot: "bg-muted-foreground", badge: "bg-muted text-muted-foreground border-border", key: "status.pending" },
  sent: { dot: "bg-amber-400", badge: "bg-amber-400/15 text-amber-600 border-amber-400/40", key: "status.sent" },
  received: { dot: "bg-emerald-500", badge: "bg-emerald-400/15 text-emerald-600 border-emerald-400/40", key: "status.received" },
  released: { dot: "bg-emerald-400", badge: "bg-emerald-500/20 text-emerald-700 border-emerald-400/50", key: "status.released" },
};

export function StatusBadge({ status }) {
  const { t } = useLanguage();
  const c = config[status] ?? config.pending;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium", c.badge)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", c.dot)} aria-hidden="true" />
      {t(c.key)}
    </span>
  );
}
